export default __webpack_public_path__ + "static/media/7.9d4c75f7.svg";